export const DATA_API_CONSTANT = {
  // Authentication
  LOGIN: 'api/auth/login',
  GET_OTP: 'api/auth/getOtp',
  VERIFY_OTP: 'api/auth/verifyOtp',
  REGISTER: 'api/auth/organizationRegister',
  FORGOT_PASSWORD_OTP: 'api/auth/getOtpForgotPassword',
  RESET_PASSWORD: 'api/auth/ResetPassword',
  SIGN_IN_OTP: 'api/auth/getOtpForEmail',
  LIST_ORGANIZATION_USERS: 'api/auth/OrganizationUsers',
  GET_ORGANIZATION_DETAILS_ID: 'api/auth/OrgUserDetailById/',
  UPDATE_USER: 'api/auth/editUser',
  ADD_EMPLOYEE: 'api/auth/CreateUser',
  GET_EMPLOYEE: 'api/auth/getprofiledetails/',
  UPDATE_PROFILE: 'api/auth/updateprofiledetails',
  CLOCK_IN: 'api/attendence/clock-in',
  GET_CLOCKIN: 'api/attendence/getclockin',
  PUT_CLOCKOUT: 'api/attendence/clock-out',
  DAILY_LOGS: 'api/attendence/dailylogs',
  MONTHLY_LOGS: 'api/attendence/monthlylogs',
  ADMIN_DAILY_LOGS: 'api/attendence/orgDailylogs',
  ADMIN_MONTHLY_LOGS: 'api/attendence/adminmonthlLogs',
  ADMIN_USER_TIME_UPDATE: 'api/attendence/users_timeupdate',
  POST_IMAGE: 'api/auth/saveimage',
  UPLOAD_DOCUMENTS: 'api/auth/uploadDocs',
  GET_DOCUMENTS: 'api/auth/getdocuments/',
  GET_DOCUMENTS_FOR_ADMIN: 'api/auth/getdocumentsadmin/',
  POST_COMPANY_OVERVIEW: 'api/company/update_companyoverview',
  GET_COMPANY_OVERVIEW: 'api/company/getcompanyoverview',
  PUT_STATUTORY: 'api/company/companyStatutory',
  POST_DEPARTMENT: 'api/company/add_department',
  GET_PROFILE_IMAGE: 'api/auth/getimage/',
  GET_DESIGNATIONS: 'api/company/getorg_designations',
  GET_DEPARTMENT: 'api/company/getorg_departments',
  DELETE_DEPARTMENT: 'api/company/delete_department',
  UPDATE_DEPARTMENT: 'api/company/update_department',
  DELETE_DOCS: 'api/auth/deletedocs',
  GET_DROPDOWNS: 'api/company/getdropdowns',
  ADD_DESIGNATION: 'api/company/addDesignations',
  DELETE_DESIGNATION: 'api/company/deletedesignation',
  CREATE_WORKWEEK_RULE: 'api/workweek/create_workrule',
  GET_WORKWEEK_RULE: 'api/workweek/getorgworkweek_rule',
  ASSIGN_WORKWEEK: 'api/workweek/assignwork_week',
  DELETE_WORKWEEK: 'api/workweek/delete_rule',
  LIST_ORGRULES: 'api/workweek/listworkweek_rules',
  ASSIGN_WORKRULE: 'api/workweek/assignwork_week',
  LIST_USERS_RULES: 'api/workweek/getusers_rules',
  GET_ASSIGNED_LEAVES: 'api/leaves/getassigned-leaves',
  APPLY_LEAVE: 'api/leaves/apply-leave',
  GET_EMPLOYEE_LOGS: 'api/leaves/getemployeelogs',
  GET_WORK_WEEK_CALENDER: 'api/workweek/getworkweekcalender/',
  UPDATE_WORK_WEEK_RULES: 'api/workweek/update_workweekrules',
  DELETE_USER_RULE: 'api/workweek/deleteuser_rule',
  GET_USER_WORK_WEEK_CALENDER: 'api/workweek/getuserworkweekrule/',
  GET_LEAVE_DETAILS: 'api/leaves/getleave-details',
  UPDATE_LEAVE_DETAILS: 'api/leaves/update-leavedetails',
  GET_ASSIGNED_USER_LEAVES: 'api/leaves/get-assigned-leave-types/',
  GET_USER_LEAVE_DETAILS: 'api/leaves/get-leave-details/',
  GET_LEAVE_VIEW_DETAILS: 'api/leaves/getleave-view-details',
  DELETE_LEAVE_APPLICATION: 'api/leaves/delete-leave-application',
  VERIFY_DOCUMENT: 'api/auth/verifydocument',
  LOGOUT_USER: 'api/auth/logout',
  GET_USERS_DETAILS: 'api/auth/getUserDetails',
  LEAVE_RECORDS_DATA: 'api/leaves/adminleave-summary',
  UPDATE_USER_STATUS: 'api/auth/updateUserStatus',
  GET_ACTIVE_USERS: 'api/auth/Directory/ActiveUsers',
  DELETE_USER: 'api/auth/delete_user',
  INVITE_TO_PROJECT: 'api/auth/invite-to-project',
  ACCEPT_PROJECT_INVITE: 'api/auth/accept-project-invite',

  // Organization List And Invite Users
  GET_ORG_USERS_DETAILS: 'api/auth/userorg-details',
  INVITE_TO_ORG: 'api/auth/invite-to-organization',
  ACCEPT_ORG_INVITE: 'api/auth/accept-org-invite',

  // superadminaccess
  LIST_ORGANIZATIONS: 'api/auth/list-organizations',
  UPDATE_ORGANIZATION: 'api/auth/updateorganization',
  DELETE_ORGANIZATION: 'api/auth/delete-organization',

  // Dashbaord
  UPCOMING_FESTIVALS: 'api/dashboard/upcoming-festivals',
  TODAYS_LEAVE_MEMBERS: 'api/dashboard/today-leave-members',
  BIRTHDAY_LIST: 'api/dashboard/birthday-list',
  WORK_ANNIVERSARY: 'api/dashboard/work-anniversary-list',
  NEW_JOINERS_LIST: 'api/dashboard/new-joiners-list',
  SEND_BIRTHDAY_WISH: 'api/dashboard/send-birthday-mail',
  GET_DAILY_THOUGHTS: 'api/dashboard/daily-thoughts',

  // Task Management
  TASK_MANAGEMENT_LIST_PROJECTS: 'api/Task-Management/admin-projects-details',
  TASK_MANAGEMENT_ADD_PROJECT: 'api/Task-Management/admin-addproject',
  TASK_MANAGEMENT_GET_DEPARTMENTS:
    'api/Task-Management/admin-alldepartmentlist',
  TASK_MANAGEMENT_GET_USERS_BY_DEPARTMENT:
    'api/Task-Management/admin-allemployeelist',
  TASK_MANAGEMENT_DEACTIVATE_PROJECT: 'api/Task-Management/deactivate-project/',

  ADD_TASK_WITHOUT_EPIC: 'api/Task-Management/tasks-add-without-epic',
  GET_CURRENT_SPRINT_TASKDETAILS:
    'api/Task-Management/task-board-details-current-sprint/',
  GET_PROJECT_ASIGNED_EMPLOYEELIST:
    'api/Task-Management/project-assigned-employees/',
  GET_TASK_BOARD_DETAILS: 'api/Task-Management/task-board-details/',
  TASK_UPDATE_STATUS: 'api/Task-Management/issue-update-status',
  LIST_TASK_BOARD_STATUS: 'api/Task-Management/all-board-status/',
  TASK_UPDATE_TITLE_ASSIGNEE:
    'api/Task-Management/issue-update-title-or-assignee',
  DELETE_TASK: 'api/Task-Management/delete-issue',
  LIST_LABEL: 'api/Task-Management/label-list/',
  CREATE_LABEL: 'api/Task-Management/create-and-update-issue-labels',
  SUBTASK_DELETE: 'api/Task-Management/delete-subtask',
  UPDATE_SUBTASK_FIELDS: 'api/Task-Management/subtask-edit',
  DELETE_STATUS_COLUMN: 'api/Task-Management/board-status-delete',
  GET_TASK_BOARD_DEATILS_BY_EPICID:
    'api/Task-Management/task-board-details-by-epic',
  GET_TASK_BOARD_WITHOUT_EPIC:
    'api/Task-Management/task-board-details-without-epic',
  //  UPDATE_LABEL:"api/Task-Management/update-task-labels",
  TASK_EDIT: 'api/Task-Management/issue-edit',
  GET_TASK_DATA: 'api/Task-Management/issue-details',
  GET_SPRINT_LIST: 'api/Task-Management/sprint-list/',
  ADD_TASK_COMMENTS: 'api/Task-Management/add-issue-comment',
  GET_TASK_COMMENTS: 'api/Task-Management/get-issue-comments',
  EDIT_COMMENT: 'api/Task-Management/edit-issue-comment',
  ADD_SUBTASK: 'api/Task-Management/subtask-add-under-task',
  GET_SUBTASK_LIST: 'api/Task-Management/subtasks-list-by-task-id',
  UPDATE_SUBTASK: 'api/Task-Management/subtask-update-fields',
  ADD_BOARD_STATUS: 'api/Task-Management/board-status-add',
  UPDATE_BOARD_STATUS_ORDER: 'api/Task-Management/update-board-status-order',

  //Task management-Backlog PAge
  TASK_MGMT_CREATE_SPRINT: 'api/Task-Management/create-sprint',
  TASK_MGMT_START_SPRINT: 'api/Task-Management/start-sprint',
  TASK_MGMT_UPDATE_SPRINT: 'api/Task-Management/update-sprint',
  GET_SPRINT_BACKLOG_DATA: 'api/Task-Management/get-sprint-backlog-data',
  DELETE_SPRINT: 'api/Task-Management/delete-sprint',
  CREATE_TASK_SPRINT: 'api/Task-Management/issue-add-with-sprintId',
  CREATE_TASK_TO_BACKLOG: 'api/Task-Management/tasks-add-without-epic',
  UPDATE_TASK_FROM_SPRINT: 'api/Task-Management/issues-update-with-sprintId',
  UPDATE_TASK_FROM_BACKLOG:
    'api/Task-Management/issue-update-title-or-assignee',
  COMPLETE_SPRINT: 'api/Task-Management/complete-sprint',
  GET_TASK_SUMMARY: 'api/Task-Management/getSprintTaskSummary',
  Task_UPDATE_WITH_SPRINTID: 'api/Task-Management/issues-update-sprint',
  MOVE_TASK_TO_SPRINT: 'api/Task-Management/issues-update-sprint',
  GET_PROJECT_ASSIGNEE_LIST: 'api/Task-Management/project-assigned-employees/',
  GET_EPIC_LIST: 'api/Task-Management/epics-list/',
  GET_LABEL_LIST: 'api/Task-Management/label-list/',
  GET_STATUS_LIST: 'api/Task-Management/board-status-list/',
  BACKLOG_PAGE_FILTER: 'api/Task-Management/filter-backlog-issues',

  TASK_MANAGEMENT_BOARD_FILTER: 'api/Task-Management/board-Filter-details', //post
  BOARD_FILTER_SPRINTS: 'api/Task-Management/sprint-list/', //get
  GET_PROJECT_ASIGNED_EMPLOYEELIST:
    'api/Task-Management/project-assigned-employees/',

  // BOARD_FILTER_ASSIGNEES:'api/Task-Management/project-assigned-employees',  //get
  BOARD_FILTER_LABELS: 'api/Task-Management/label-list/', // get
  BOARD_FILTER_STATUS: 'api/Task-Management/all-board-status/', // post
  BOARD_FILTER_EPICS: 'api/Task-Management/board-epics-list?project_id=', //get

  TASK_MANAGEMENT_EDIT_PROJECT: 'api/Task-Management/admin-Editproject',
  TASK_MANAGEMENT_DELETE_PROJECT: 'api/Task-Management/delete-project/',
  TASK_MANAGEMENT_GET_UNSELECTED_EMPLOYEES:
    'api/Task-Management/admin-get-unselected-employees',
  TASK_MANAGEMENT_UPDATE_PROJECT_DEPARTMENTS:
    'api/Task-Management/admin-update-project-departments',
  TASK_MANAGEMENT_ADD_PROJECT_MEMBERS:
    'api/Task-Management/admin-add-project-members',
  TASK_MANAGEMENT_GET_PROJECT_DETAILS: 'api/Task-Management/project-details/',
  TASK_MANAGEMENT_REMOVE_PROJECT_MEMBERS:
    'api/Task-Management/admin-remove-project-members',
  GET_EPIC: 'api/Task-Management/epics-list',
  GET_SELECTED_PROJECT_ROLE_PERMISSION:
    'api/Task-Management/user-project-role-permissions/',
  GET_ALL_PROJECT_ROLE_PERMISSIONS:
    'api/Task-Management/user-projects-role-permissions/',
  ADD_WORK_ITEM: 'api/Task-Management/workitem-add',
  TAST_MANAGEMENT_ADD_EPIC: 'api/Task-Management/admin-add-epic',

  EXPORT_TASK_DATA: 'api/Task-Management/export-project-data',

  //chatbot api
  CHAT_BOT: 'api/chatbot/ask-chatbot',

  // Features
  FEATURE_LIST: 'api/auth/getFeatures',
  ADD_FEATURE: 'api/auth/add-feature',
  ASSIGN_FEATURE: 'api/auth/assign-features',
  ASSIGNED_FEATURE_ORG: 'api/auth/getAssignedFeatureOrg',
  DELETE_FEATURE: 'api/auth/delete-feature',
  DELETE_ASSIGNED_FEATURE: 'api/auth/delete-assigned-feature',

  TIMELINE_SPRINT_LIST: 'api/Task-Management/get-timeline-sprints',
  TIMELINE_GETEPIC_LIST: 'api/Task-Management/get-epics-by-project',
  TIMELINE_TASK_LIST: 'api/Task-Management/get-epic-tasks-with-sprints',
  UPDATE_TIMELINE_TASKEPIC: 'api/Task-Management/change-task-epic',
  UPDATE_EPIC_DETAILS: 'api/Task-Management/admin-edit-epic',
  UPDATE_SPRINTS_DETAILS: 'api/Task-Management/update-sprint',
  ADD_TASK_WITH_EPIC: 'api/Task-Management/tasks-add-with-epic',
  CREATE_AND_ADD_EPICLABELS:
    'api/Task-Management/create-and-update-epic-labels',
  ADD_EPIC_COMMENT: 'api/Task-Management/add-epic-comment',
  EDIT_EPIC_COMMENT: 'api/Task-Management/edit-epic-comment',
  GET_EPIC_COMMENT: 'api/Task-Management/get-epic-comments',
  GET_EPIC_DETAILSBYID: 'api/Task-Management/EpicDetailById',
  TIMELINE_FILTER_DETAILS: 'api/Task-Management/timeline-filter-details',
  GET_EPIC_DETAILS_WITHTASK: 'api/Task-Management/epic-details-with-tasks',
  GET_TIMELINE_FILTERED_LIST: 'api/Task-Management/timeline-filter-details',
  DELETE_TASK_COMMENT: 'api/Task-Management/delete-issue-comment',

  GET_SUBTASK_DETAILS_BYID: 'api/Task-Management/subtask-details-by-id',
  UPDATE_SUBTASK_LABELS: 'api/Task-Management/create-and-update-subtask-labels',
  GET_TASK_WITH_EPICID: 'api/Task-Management/get-issue-by-epic',
  CREATE_ADD_EPIC_LABELS: 'api/Task-Management/create-and-update-epic-labels',
  DELETE_EPIC_COMMENT: 'api/Task-Management/deleteEpicComment',
  UPDATE_SUBTASK_DATA: 'api/Task-Management/subtask-update-fields',
  CREATE_SUBTASK_COMMENT: 'api/Task-Management/create-subtask-comment',
  GET_SUBTASK_COMMENTS: 'api/Task-Management/get-subtask-comments',
  // EDIT_SUBTASK_COMMENT:'api/Task-Management/editSubtaskComment',
  EDIT_SUBTASK_COMMENT: 'api/Task-Management/edit-subtask-comment',
  DELETE_SUBTASKCOMMENT: 'api/Task-Management/delete-subtask-comment',
  GET_EPICS_AND_TASKS_WITH_SUBTAKS:
    'api/Task-Management/export-project-epic-data',
  UPDATE_EPIC_POSITION: 'api/Task-Management/update-epic-positions',

  // TASK MANAGEMENT SUMMARY DASHBOARD
  GET_SUMMARY_DASHBOARD: 'api/Task-Management/summary/filter',

  //List module
  GET_LIST_DATA: 'api/Task-Management/list/project-data',
  REODRDER_TASK_IN_SPRINT: 'api/Task-Management/update-issue-positions',
  GET_ADMINTASK_BOARD_DETAILS: 'api/Task-Management/get-all-task-board',
  LIST_FILTER_DETAILS: 'api/Task-Management/list/filter',
  ADMIN_BOARD_FILTER: 'api/Task-Management/admin-board-Filter-all-details',

  // upload attachment api's
  UPLOAD_ATTACHMENT: 'api/Task-Management/upload-attachment',
  GET_ATTACHMENT: 'api/Task-Management/get-attachments',
  DELETE_ATTACHMENT: 'api/Task-Management/delete-attachment',
  DOWNLOAD_ATTACHMENT: 'api/Task-Management/download-attachment',

  // share work item api
  SHARE_WORK_ITEM: 'api/Task-Management/share-work-item',
  GET_ISSUE_TYPES: 'api/Task-Management/issue-types',
  TIME_TRACKING:'api/Task-Management/work-time-tracking',
  GET_LOGGED_TIME: 'api/Task-Management/get-logged-time',
  GET_HISTORICAL_LOGS: 'api/Task-Management/get-work-log-history',
  GET_WORKLOG_TIME:'api/Task-Management/get-worklog-time',
  UPDATE_LOG_TIME:'api/Task-Management/update-logged-time',
  DELETE_LOG_TIME:'api/Task-Management/delete-log',

  // dashboard metrics api for project section
  DASHBOARD_METRICS: 'api/dashboard/get-Main-Dashboard',
  // TASK_BOARD_DETAILS_USER: 'api/dashboard/get-my-work',
  // DASHBOARD_METRICS_TASKS_BY_STATUS:'api/Task-Management/get-Main-Dashboard',
  UPDATE_HORIZONTAL_DASHBOARD_CONFIG: 'api/dashboard/update-dashboard-config',
  GET_HORIZONTAL_DASHBOARD_CONFIG: 'api/dashboard/get-dashboard-config',
 UPDATE_METRIC_SEQUENCE: 'api/dashboard/update-metric-sequence',
 GET_METRIC_SEQUENCE: 'api/dashboard/get-metric-sequence',
 UPDATE_VERTICAL_DASHBOARD_CONFIG: 'api/dashboard/update-vertical-dashboard-config',
  GET_VERTICAL_DASHBOARD_CONFIG: 'api/dashboard/get-vertical-dashboard-config',
 GET_VERTICAL_DASHBOARD_SEQUENCE: 'api/dashboard/get-vertical-widget-sequence',
  UPDATE_VERTICAL_DASHBOARD_SEQUENCE: 'api/dashboard/update-vertical-widget-sequence',



  // Link Items api
   LIST_LINK_TYPES:'api/Task-Management/list-link-types',
   CREATE_LINK_TYPES:'api/Task-Management/create-link-type',
   LIST_WORKITEMS_FOR_LINKING:'api/Task-Management/list-workitems-for-linking',
   LINK_WORK_ITEMS:'api/Task-Management/create-workitem-link',
   DELETE_WORK_ITEM:'api/Task-Management/delete-link-workitem/',
   UPDATE_LINK_TYPE_STATUS:'api/Task-Management/toggle-link-type-status',
   GET_LINKED_WORKITEMS:'api/Task-Management/get-linked-workitems',
   FETCH_LINKEDWORK_ITEMS_COUNT:'api/Task-Management/fetch_linkedItem_count/',
   DELETE_LINK_TYPE:'api/Task-Management/delete-link-type',



  // confluence
   GET_ICONS: 'api/Confluence/spaces/Logos',
  CREATE_SPACE: 'api/Confluence/spaces/create-space',
  GET_SPACES: 'api//Confluence/spaces/space-filter',
  GET_SPACE_DETAILS: 'api/Confluence/spaces/space-details-by-id',
  GET_SPACE_CONTENT: 'api/Confluence/space/',
  GET_YOUR_SPACES: 'api/Confluence/spaces/your-spaces',
  GET_TRASHED_SPACES: 'api/Confluence/spaces/get-trashed-space',
  DRAFT_PAGE: 'api/Confluence/content/Draft-page',
  CREATE_FOLDER: 'api/Confluence/content/Create-folder',
  RENAME_CONTENT: 'api/Confluence/content/Rename',
  GET_VERSION_HISTORY: "api/Confluence/spaces/:space_id/items/:item_id/version-history/:type",

  GET_TEMPLATE: `api/Confluence/spaces/GetTemplates`,
  EDIT_PAGE_CONTENT: 'api/Confluence/content/Edit',
  GET_PAGE_CONTENT: 'api/Confluence/:space_id/nodes/share/:item_id/check',
  MOVE_PAGE_OR_FOLDERS: 'api/Confluence/content/Drag-and-Drop',
  ARCHIVE_OR_DELETE_PAGE_FOLDER:
    'api/Confluence/content/Update-Item-Status-Archive-Or-Delete',
  DUPLICATE_CONTENT: 'api/Confluence/space/create_duplicate_item',
  TEMPLATEDRAFTPAGE: 'api/Confluence/template-Draft-page',
  STAR_SHORTCUT: 'api/Confluence/content/Star-Shortcuts',
  PUBLISH_PAGE: 'api/Confluence/content/Page-Publish',
  GETSPACEUSERS:'api/Confluence/space/:space_id/users',
  POST_PAGE_COMMENT:'api/Confluence/space/doc/comment',
  GET_PAGE_COMMENT:'api/Confluence/space/:space_id/item/:item_id/type/:type/get-comment',
  EDIT_PAGE_COMMENT:'api/Confluence/space/item/update-comment',
  DELETE_PAGE_COMMENT:'api/Confluence/spaces/:space_id/items/:item_id/comments/:id',
  SHAREITEM:'api/Confluence/nodes/:item_id/share',
  GET_ARCHIVED_SPACE:'api/Confluence/spaces/get-archived-space',
  PATCH_RESTORE_OR_TRASH:'api/Confluence/spaces/Activate-or-Move-to-Trash',
  GET_STARRED_CONTENT:'api/Confluence/space/:space_id/starred_item',
  UPLOAD_SPACE_ATTACHMENT:'api/Confluence/space/doc/attachment',
  GET_SPACE_ATTACHMENT:'api/Confluence/attachment/:space_id/:item_id',
  DELETE_SPACE_ATTACHMEMT:'api/Confluence/delete-attachment/:space_id/:item_id/:id',
  GET_OWNER_SPACE:'api/Confluence/owner-spaces',
  GET_DELETE_AND_ARCHIVED_CONTENT:'api/Confluence/settings/Get-TrashAndArchived-Space-ItemTree?space_id=',
  RESTORE_TRASHED_CONTENT:'api/Confluence/setting/Restore-Item-From-ArchiveOrDelete',
  DELETE_DRAFT_PAGE:'api/Confluence/settings/delete-draft-item/:space_id/:item_id',
  COMPARE_VERSION:'api/Confluence/space/versions/compare',
  SAVE_PADE_DATA:'api/Confluence/content/save',
  RESTORE_VERSION:'api/Confluence/content/Restore-Item-Version',
  DELETE_VERSION:'api/Confluence/content/Delete-Item-Version/:space_id/:item_id/:version_id',
  LIST_ALL_ORG_USERS:'api/Confluence/settings/user-list',
  ADD_USERS_TO_SPACE:'api/Confluence/add-user-to-space',
  PERMANENTLY_DELETE_ITEM:'api/Confluence/settings/space/:space_id/item/:item_id/delete',
  REMOVE_MEMBERS_FROM_SPACE:'api/Confluence/space/settings/remove-user',
  CREATE_WHITEBOARD:'api/Confluence/content/create-whiteboard',
  POST_WHITEBOARD_CONTENT:'api/Confluence/content/Edit',
  GET_VERSION_DETAILS:'api/Confluence/space/:space_id/version-content/:version_id',
  CREATE_DATABASE:'api/Confluence/content/create-database',
  GET_COLUMN_LIST:'api/Confluence/content/get-column-list/:space_id/:item_id',
  DATABSE_FILTERS:'api/Confluence/content/database/filters',
  GET_SAVED_FILTERS:'api/Confluence/content/filter/:space_id/:item_id',
  DELETE_SAVED_FILTERS:'api/Confluence/content/delete-filter/:space_id/:item_id/:id',
  DATABASE_COLUMN_CALCULATION:'api/Confluence/content/column-calculation',
  CONTENT_EXPORT:'api/Confluence/content/export',
  ALL_SPACE_PERMISSION:'api/Confluence/user/space-role-permissions',
  SINGLE_SPACE_PERMISSION:'api/Confluence/spaces/:space_id/user-role-permissions',

  // weblink api
  ADD_WEB_LINK:'api/task-management/add-weblink',
  GET_WEB_LINKS:'api/task-management/get_weblinks',
  DELETE_WEB_LINKS:'api/task-management/delete_weblinks',

  // demo project
  CREATE_DEMO_PROJECT:'api/Task-Management/demo-project',
  UPDATE_TOUR_STATUS : 'api/auth/tour-status',
  UPDATE_PROJECT_TOUR_STATUS:'api/auth/project_tour-status',

  // subscripion
  GET_SUBSCRIPTION_PLANS:'api/subscription/plans',
  CREATE_SUBSCRIPTION:'api/subscription/plan/create',
  UPDATE_SUBSCRIPTION:'api/subscription/plan/update',
  CHANGE_SUBSCRIPTION_STATUS:'api/subscription/plan/change-status',
  ACTIVATE_SUBSCRIPTION:'api/subscription/activate',
  ASSIGN_SUBSCRIPTION:'api/subscription/assign',
  GET_ADMIN_LIST:'api/subscription/admin/list',
  CHANGE_PLAN_STATUS:'api/subscription/plan/change-status',
  ASSIGN_PLAN:'api/subscription/assign',





};
